import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TalentMetrics, AIRecommendation, DashboardCard } from '../types';

interface DashboardState {
  metrics: TalentMetrics | null;
  aiRecommendations: AIRecommendation[];
  dashboardCards: DashboardCard[];
  loading: boolean;
  error: string | null;
  lastUpdated: string | null;
}

const initialState: DashboardState = {
  metrics: null,
  aiRecommendations: [],
  dashboardCards: [],
  loading: false,
  error: null,
  lastUpdated: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setMetrics: (state, action: PayloadAction<TalentMetrics>) => {
      state.metrics = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
    setAIRecommendations: (state, action: PayloadAction<AIRecommendation[]>) => {
      state.aiRecommendations = action.payload;
    },
    setDashboardCards: (state, action: PayloadAction<DashboardCard[]>) => {
      state.dashboardCards = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    updateCard: (state, action: PayloadAction<DashboardCard>) => {
      const index = state.dashboardCards.findIndex(card => card.id === action.payload.id);
      if (index !== -1) {
        state.dashboardCards[index] = action.payload;
      }
    },
  },
});

export const {
  setMetrics,
  setAIRecommendations,
  setDashboardCards,
  setLoading,
  setError,
  updateCard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;